import axios from '../index'

function listMgrCdMng(params) {
  return axios.get('/api/admin/listMgrCdMng', params)
}
function getMgrCdMng(params) {
  return axios.get('/api/admin/getMgrCdMng', params)
}
function insertMgrCdMng(params) {
  return axios.post('/api/admin/insertMgrCdMng', null, params)
}
function updateMgrCdMng(params) {
  return axios.post('/api/admin/updateMgrCdMng', null, params)
}
function deleteMgrCdMng(params) {
  return axios.post('/api/admin/deleteMgrCdMng', null, params)
}

export default {
  listMgrCdMng,
  getMgrCdMng,
  insertMgrCdMng,
  updateMgrCdMng,
  deleteMgrCdMng,
}
